// Prices page component
export function FaqCustomerInfoPage() {
    return `
<div class="min-h-screen bg-gray-50">
    <div class="hero">
        <div class="hero-content">
            <h1 class="hero-title">Información</h1>
            <p class="hero-subtitle">Para clientes</p>
        </div>
    </div>

    <section class="section bg-gray-50">

        <div class="container">
           <div class="md:flex md:items-start md:space-x-8">

            <main class="md:w-2/3">

                <div class="max-w-4xl mx-auto prose prose-lg">

                    <div class="bg-white p-8 rounded-lg shadow-sm">
                        <h2 id="can-i-object" class="text-2xl text-blue-900 mb-4">¿Puedo presentar una objeción contra el certificado energético?</h2>
                        <p class="mb-4">¿No estás de acuerdo con el certificado energético asignado a tu vivienda o local comercial? Por ejemplo, porque crees que el técnico certificador energético no ha evaluado correctamente el inmueble o que ciertas características no fueron incluidas en el cálculo.

Primero contacta directamente con el asesor que elaboró el certificado energético. Explica por qué no estás de acuerdo con su evaluación. En muchos casos, el asesor puede revisar el cálculo o, si es necesario, programar una nueva visita.

¿No conseguís resolverlo? Entonces puedes ponerte en contacto con el organismo competente autonómico donde se registró el certificado. Cada región española tiene su propia autoridad encargada del control y registro de los certificados energéticos. Esta entidad puede investigar si el registro se realizó correctamente según la normativa nacional (Real Decreto 390/2021).

¿Eres inquilino y crees que el certificado energético no es correcto? Contacta primero al propietario. El propietario puede seguir los mismos pasos: consultar con el técnico certificador o, si es necesario, presentar una reclamación ante el organismo competente autonómico.

Un certificado energético correcto es importante, ya que puede influir en el precio del alquiler y en la valoración del inmueble.</p>
                    </div>
                </div>

                <br></br>

                <div class="max-w-4xl mx-auto prose prose-lg">
                    <div class="bg-white p-8 rounded-lg shadow-sm">
                        <h2 id="where-can-i-find" class="text-2xl text-blue-900 mb-4">¿Dónde puedo consultar el certificado energético de mi vivienda o local?</h2>
                        <p class="mb-4">¿Quieres consultar el certificado energético de tu vivienda o empresa? En España los certificados energéticos no se registran a nivel nacional, sino regional. Cada comunidad autónoma tiene su propia base de datos oficial donde se almacenan y verifican todos los certificados. Después de que el técnico certificador energético elabora el certificado, lo registra en el organismo competente autonómico.

Tras el registro, recibirás el certificado energético oficial por correo electrónico en formato PDF, junto con el número de registro otorgado por la administración regional. Ese número demuestra que el certificado es válido y está oficialmente registrado.

Un certificado energético registrado en España tiene una validez de 10 años desde la fecha de registro. Durante ese periodo, cualquier persona —como compradores o arrendatarios potenciales— puede consultar el certificado a través del registro público de la región correspondiente. Esto ofrece una visión clara del rendimiento energético del inmueble, lo cual facilita una comparación justa entre viviendas y edificios.

También es obligatorio indicar la clase energética (de la A a la G) en anuncios de venta o alquiler, tanto online como offline.

¿No aparece tu certificado en el registro regional? Entonces puede que haya caducado o que no esté registrado correctamente. A través de CEEcasasespaña.com puedes seleccionar fácilmente un nuevo asesor y obtener en pocos días un certificado energético válido y oficialmente registrado.</p>
                    </div>
                </div>

                <br></br>

                <div class="max-w-4xl mx-auto prose prose-lg">
                    <div class="bg-white p-8 rounded-lg shadow-sm">
                        <h2 id="how-is-performance-determined" class="text-2xl text-blue-900 mb-4">¿Cómo se determina la eficiencia energética de mi vivienda o local?</h2>
                        <p class="mb-4">¿Cómo se determina la eficiencia energética de mi vivienda?

Después de seleccionar un técnico certificador energético a través de CEEcasasespaña.com, el asesor se pondrá en contacto contigo para planificar una cita. Durante la visita —que suele durar entre una hora y hora y media— el asesor evaluará la eficiencia energética de tu vivienda conforme a la normativa española (Real Decreto 390/2021).

La evaluación se basa en más de 150 características del inmueble, como:
• las características generales (dimensiones, año de construcción y tipo de vivienda);  
• la superficie del suelo, tejado y fachada;  
• el aislamiento de la cubierta, paredes, suelo y ventanas;  
• las instalaciones de calefacción, agua caliente, ventilación, climatización y energía solar.

El certificado energético se calcula a partir del consumo teórico de energía en kWh por m² al año y del porcentaje de energía renovable. Cuanto menor sea el consumo energético y mayor el uso de energía renovable, mejor será la calificación energética de la vivienda.



¿Cómo se determina la eficiencia energética de mi local comercial?

Para locales comerciales el proceso es muy similar. Una vez seleccionado el técnico certificador a través de CEEcasasespaña.com, el asesor concertará una cita contigo. La duración de la visita depende del tamaño y la complejidad del edificio.</p>
                    </div>
                </div>

                <br></br>

                <div class="max-w-4xl mx-auto prose prose-lg">
                    <div class="bg-white p-8 rounded-lg shadow-sm">
                        <h2 id="how-fast" class="text-2xl text-blue-900 mb-4">¿Cuánto tardaré en recibir un certificado energético?</h2>
                        <p class="mb-4">El tiempo necesario para recibir tu certificado energético depende sobre todo de la ubicación de la vivienda o local. En cada región de España trabajan distintos técnicos certificadores energéticos, cada uno con su propia disponibilidad y plazo de entrega.

Por lo general, podrás recibir el certificado energético entre unos pocos días y dos semanas después de la inspección. El plazo exacto depende de:
• la comunidad autónoma en la que se encuentra el inmueble;  
• la disponibilidad del técnico elegido;  
• la superficie y complejidad del inmueble.

Un apartamento pequeño suele poder completarse en pocos días, mientras que un edificio grande o con varias plantas puede requerir más tiempo para la evaluación y redacción del informe.

¿Necesitas el certificado con urgencia, por ejemplo para vender o alquilar? En CEEcasasespaña.com puedes filtrar por plazo de entrega. Algunos asesores ofrecen un servicio urgente por un precio ligeramente superior, para que puedas disponer de un certificado registrado en pocos días.</p>
                    </div>
                </div>

                <br></br>

                <div class="max-w-4xl mx-auto prose prose-lg">
                    <div class="bg-white p-8 rounded-lg shadow-sm">
                        <h2 id="data-from-government" class="text-2xl text-blue-900 mb-4">¿Cómo obtenemos los datos de tu vivienda o local de las autoridades?</h2>
                        <p class="mb-4">Cuando buscas un técnico certificador a través de CEEcasasespaña.com, te pedimos algunos datos básicos del inmueble, como:
• la dirección de la vivienda o local;  
• el tipo de edificio (apartamento, vivienda unifamiliar o espacio de oficina);  
• y, si se conoce, la superficie del edificio.

Con esta información mostramos los asesores disponibles en tu región, con sus precios, valoraciones y plazos de entrega. Así puedes comparar fácilmente y seleccionar al asesor que mejor se adapte a tus necesidades.

En España, los datos oficiales de los inmuebles son gestionados por el Catastro, el registro catastral del Estado. Esta base de datos contiene información sobre ubicación, superficie útil, año de construcción y uso del inmueble. Los técnicos certificadores utilizan estos datos como comprobación durante la inspección, pero CEEcasasespaña.com no consulta estos datos automáticamente. Tú siempre mantienes el control sobre la información que proporcionas.

Durante la inspección, el técnico verificará las características principales del inmueble —como dimensiones, uso y tipo de construcción— para asegurarse de que el certificado energético se elabore con información correcta y actualizada.</p>
                    </div>
                </div>

                <br></br>

                <div class="max-w-4xl mx-auto prose prose-lg">
                    <div class="bg-white p-8 rounded-lg shadow-sm">
                        <h2 id="price" class="text-2xl text-blue-900 mb-4">¿Cuál es el precio de un certificado energético?</h2>
                        <p class="mb-4">El precio de un certificado energético para una vivienda o local en España depende de varios factores. Los principales son:

• El tipo de edificio – Un certificado para un apartamento suele ser más económico que para una vivienda unifamiliar, oficina o local comercial.  
• La superficie – Cuanto mayor sea el inmueble, más tiempo necesitará el técnico para la inspección y el cálculo, y mayor será el precio.  
• La complejidad del edificio – Inmuebles con varias plantas, ampliaciones o usos mixtos requieren más trabajo de medición y análisis.  
• La región – En cada comunidad autónoma trabajan distintos técnicos certificadores, cada uno con sus propias tarifas y disponibilidad.

Los precios de un certificado energético en España suelen oscilar entre **100 € y 250 € para viviendas**, y entre **200 € y 600 € para locales comerciales**, dependiendo del tamaño y ubicación.</p>

<p class="mb-4">
¿Quieres saber exactamente cuánto cuesta el certificado energético para tu vivienda o local comercial?
Utiliza entonces el comparador de CEEcasasespaña.com. Verás de inmediato:

los asesores disponibles en tu región,

sus precios, plazos de entrega y valoraciones,

y qué opciones existen para un servicio urgente.

Así podrás elegir fácilmente al asesor que mejor se adapte a tu situación y presupuesto.
</p>

<h2 class="text-2xl text-blue-900 mb-4">¿Quién es el asesor de certificados energéticos más adecuado para mí?</h2>

<p class="mb-4">
Cuál es el mejor técnico certificador energético para ti depende de tu situación y preferencias.
A través de CEEcasasespaña.com puedes encontrar fácilmente al asesor que mejor se ajuste a tus necesidades.

Introduce en nuestro comparador la dirección o el código postal de tu vivienda o local.
Después indicas de qué tipo de inmueble se trata —por ejemplo, apartamento, vivienda unifamiliar o espacio de oficina. También puedes introducir la superficie (o ajustarla si no es exacta).

Nuestro comparador muestra automáticamente los asesores energéticos certificados disponibles en tu región, incluyendo:
• sus precios,  
• el plazo estimado de entrega,  
• y las valoraciones de otros clientes.

Luego puedes filtrar fácilmente según lo que tú consideres importante:
por ejemplo el precio más bajo, la entrega más rápida o el asesor mejor valorado.

Una vez que hayas encontrado al asesor adecuado, rellenas en el formulario de solicitud algunos datos adicionales para que el técnico pueda ponerse en contacto contigo y planificar la visita. Este formulario aparecerá al hacer clic en el botón verde “Solicitar” junto al asesor elegido.

Tras enviar la solicitud, el técnico recibirá tus datos y se pondrá en contacto contigo para confirmar la inspección.
Todos los asesores en CEEcasasespaña.com trabajan con tarifas transparentes: lo que ves en el comparador es lo que pagarás. Si algo no coincide, no dudes en contactar con nuestro servicio de atención al cliente a través de info@CEEcasasespaña.com.
</p>

<h2 class="text-2xl text-blue-900 mb-4">¿Cuáles son nuestros requisitos para los asesores de certificados energéticos?</h2>

<p class="mb-4">
Para poder operar en CEEcasasespaña.com, todos los técnicos certificadores energéticos deben estar oficialmente acreditados y autorizados para emitir certificados energéticos conforme a la legislación española (Real Decreto 390/2021).

Esta normativa establece que los asesores deben contar con una formación técnica adecuada —como arquitectura, ingeniería o aparejador— y estar habilitados para realizar y registrar certificados de eficiencia energética ante el organismo competente autonómico.

Además, todos los asesores que trabajan a través de CEEcasasespaña.com deben:
• tener experiencia demostrable en certificación energética;  
• utilizar los métodos oficiales españoles (como CE3X o HULC);  
• cumplir con las normas de calidad establecidas en el Real Decreto 390/2021;  
• y trabajar con tarifas transparentes y comunicación orientada al cliente.

Por último, valoramos enormemente la profesionalidad, la fiabilidad y la amabilidad.
Por eso seleccionamos únicamente a asesores que no solo son técnicamente competentes, sino que también se comunican de forma clara y acuden a los clientes con una actitud cordial.
</p>

<h2 class="text-2xl text-blue-900 mb-4">¿Qué hace un asesor de certificados energéticos en tu vivienda?</h2>

<p class="mb-4">
El técnico certificador energético examina tu vivienda de arriba a abajo para determinar su eficiencia energética. Esta inspección es obligatoria en España según el Real Decreto 390/2021.

Primero, el asesor comenta contigo la información básica de la vivienda. ¿Tienes planos, fotos o facturas de reformas anteriores? Esto ayuda a obtener una imagen más precisa de las características energéticas del inmueble.

Después realiza la inspección física. Comprueba:
• el aislamiento de paredes, suelos, cubierta y ventanas;  
• el tipo de acristalamiento (simple, doble o triple);  
• el grosor de las capas aislantes;  
• las instalaciones de calefacción, agua caliente y climatización;  
• posibles fuentes de energía renovable como placas solares o bombas de calor;  
• y los sistemas de ventilación del inmueble.

El asesor puede usar equipos de medición para determinar si las ventanas tienen capas aislantes y qué capacidad tiene la vivienda para retener calor. Menor pérdida de calor significa menor consumo energético, y por tanto una mejor calificación.

La inspección completa suele durar entre 45 minutos y una hora y media, según el tamaño y complejidad del inmueble.
Tras la visita, el asesor introduce todos los datos en el software oficial (CE3X o HULC), calcula la eficiencia energética y registra el certificado en el organismo competente autonómico.

Después recibirás el certificado energético oficial en formato PDF, incluyendo el comprobante de registro.

La elaboración de un certificado energético es un trabajo técnico que requiere precisión y conocimientos especializados.
A través de CEEcasasespaña.com puedes encontrar fácilmente a los mejores técnicos certificados en tu zona —basado en precio, valoración y plazo de entrega— para asegurarte de que tu certificado sea correcto y oficial.
</p>

<h2 class="text-2xl text-blue-900 mb-4">¿Puedo solicitar un certificado energético como representante o heredero?</h2>

<p class="mb-4">
¿Eres representante o heredero de una vivienda o local comercial?
Entonces puedes solicitar fácilmente un certificado energético en nombre del propietario a través de CEEcasasespaña.com.
En la página principal introduce los datos del inmueble —como dirección, tipo de edificio y superficie estimada. A continuación, nuestro comparador mostrará los técnicos certificadores energéticos disponibles en la región del inmueble.

Luego puedes filtrar por:
• precio,  
• plazo de entrega,  
• y valoración de los asesores.

¿Has elegido al asesor que mejor se ajusta a tus necesidades? Haz clic en el botón verde “Solicitar”. Serás redirigido al formulario donde introduces tus datos y los del inmueble. El asesor elegido recibirá la solicitud y se pondrá en contacto contigo para planificar la inspección.

¿Eres agente inmobiliario y quieres solicitar un certificado para un cliente?
También es posible a través de CEEcasasespaña.com. Introduce la dirección y datos del inmueble, compara los asesores disponibles y elige el que mejor se adapte a tu agenda o preferencias.
Una vez enviada la solicitud, el asesor contactará directamente contigo o con el propietario para confirmar la inspección.

De este modo, como representante, heredero o agente inmobiliario puedes garantizar rápidamente que el inmueble disponga de un certificado energético válido y registrado oficialmente —sin procedimientos complicados.
</p>

<h2 class="text-2xl text-blue-900 mb-4">¿Cómo puedo cancelar una solicitud de certificado energético?</h2>

<p class="mb-4">
En CEEcasasespaña.com nos esforzamos por hacer que el proceso de solicitar un certificado energético sea lo más claro y sencillo posible.
Cuando envías una solicitud, tanto tú como el asesor seleccionado recibís de inmediato información completa sobre los costes, sin sorpresas posteriores.

Todos los precios que ves en nuestra web son tarifas completas, con IVA y posibles gastos de desplazamiento incluidos.
Así siempre sabrás exactamente lo que pagarás y podrás elegir fácilmente al asesor que mejor se adapte a tus necesidades.

No trabajamos con presupuestos tradicionales, sino con órdenes de servicio claras, para que el técnico pueda comenzar directamente con la preparación de la inspección y el cálculo del certificado.

Entendemos, sin embargo, que los planes pueden cambiar. Por eso te ofrecemos la posibilidad de cancelar tu solicitud mientras la inspección no haya tenido lugar.
Cualquier condición o coste de cancelación será siempre claramente indicado por el asesor antes de que confirmes la solicitud.

Nuestra filosofía se basa en claridad, confianza y flexibilidad —para que tengas una experiencia agradable y nuestros asesores puedan trabajar de forma eficiente.
En CEEcasasespaña.com creemos que esta es la base ideal para una colaboración profesional y transparente.
</p>

<p class="mb-4">Inicia tu comparación con asesores de certificados energéticos en España.</p>

<p><a href="/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Comparar asesores</a></p>

        `;
}